import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

const baseUrl = process.env.NODE_ENV === 'production'
  ? 'https://ui-tasks.netlify.app'
  : 'http://localhost:3000';

const ShareBtn = () => {
  const location = useLocation();
  const url = `${baseUrl}${location.pathname}`;
  const [copy, setCopy] = useState(false);

  const handleShareClick = () => {
    navigator.clipboard.writeText(url).then(() => {
      setCopy(true);
      const setTimeoutId = setTimeout(() => {
        setCopy(false);
      }, 2000);

      return () => {
        clearTimeout(setTimeoutId);
      };
    });
  };

  return (
    <>
      <div className="share__container">
        <button onClick={handleShareClick} className="share__btn" type="button">Share</button>
        {copy && <p className="share__popup">Copied!</p>}
      </div>
    </>
  );
};

export default ShareBtn;
